@use "legend-layout" as *;

.element {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  width: 100%;
  border-right: 1px solid var(--color-border-primary);
}

.map-legend-wrapper {
  color: var(--color-text-primary);
  background-color: var(--color-bg-primary);
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  height: calc(100% - #{$legend-controls-height});
  width: 100%;
  box-sizing: border-box;
}
